module.exports = __webpack_public_path__ + "02c10342d54f87630f27ff3518bd41de.svg";